<template>
  <div>
    <v-dialog
        v-model="dialog"
        max-width="500px"
        persistent
    >
      <v-card>
        <v-card-title>Add Comment</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert
              :value="errorAlert"
              type="error"
              outlined
              transition="scale-transition"
              class="mt-2"
          >
            {{ errorMessage }}
          </v-alert>
          <v-textarea
              v-model="comment"
              v-validate="{ required: true }"
              name="Comment"
              :error-messages="errors.collect('comment')"
              label="Comment"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer />
          <v-btn
              text
              color="blue darken-1"
              @click="hide"
          >
            Cancel
          </v-btn>
          <v-btn
              text
              color="primary"
              :loading="sending"
              @click="send"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import errorAlertMixins from '@/mixins/errorAlertMixins';
import flaggedUsers from '@/api/flaggedUsers';

export default {
  name: 'AddFlagCommentPopup',
  mixins: [errorAlertMixins],
  props: {
    incidentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      comment: null,
      sending: false,
    };
  },
  methods: {
    /**
     * Show add comment popup.
     */
    show() {
      this.dialog = true;
      this.comment = null;
    },

    /**
     * Hide popup.
     */
    hide() {
      this.dialog = false;
    },

    /**
     * Send request for adding comment.
     */
    async send() {
      this.hideError();
      await this.$validator.reset();

      if (!await this.$validator.validateAll()) {
        return;
      }

      this.sending = true;

      try {
        await flaggedUsers.addFlagComment(this.incidentId, { comment: this.comment });
        this.dialog = false;
        this.$emit('sentComment');
      } catch (e) {
        this.parseErrorResponse(e.response);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style scoped>

</style>
